export default function (form) {
    const $form = jQuery(form);

    $form.bind('submit', function () {
        const url = form.action;
        const formData = new FormData(form);
        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(res => res.text())
            .then(response => {
                document.getElementById('expert-teaser-cards').innerHTML = response;
                console.log(response);
            })
            .catch(error => console.log(error));

        return false;
    });

    $form.submit();
}
